import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/opt/www-roomvia-ai/app/components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingPage"] */ "/opt/www-roomvia-ai/app/pages/pricing/PricingPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/www-roomvia-ai/node_modules/.pnpm/next@15.2.8_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/dist/client/app-dir/link.js");
